import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { UzurvDirectivesModule } from '@uzurv/core';
import { GenericSearchSelectModule } from '../../generic-search-select';
import { ExpressProviderDriverInterestDialogComponent } from './express-provider-driver-interest-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    MatCheckboxModule,
    GenericSearchSelectModule,
    UzurvDirectivesModule
  ],
  declarations: [ExpressProviderDriverInterestDialogComponent],
  exports: [ExpressProviderDriverInterestDialogComponent]
})
export class ExpressProviderDriverInterestDialogModule {}
